__turbopack_context__.v({
  "activeSwatch": "ai-features-module-scss-module__zCj01G__activeSwatch",
  "answer": "ai-features-module-scss-module__zCj01G__answer",
  "ask": "ai-features-module-scss-module__zCj01G__ask",
  "builtToWin": "ai-features-module-scss-module__zCj01G__builtToWin",
  "cardDescription": "ai-features-module-scss-module__zCj01G__cardDescription",
  "cardLabel": "ai-features-module-scss-module__zCj01G__cardLabel",
  "cardMeta": "ai-features-module-scss-module__zCj01G__cardMeta",
  "chat": "ai-features-module-scss-module__zCj01G__chat",
  "chatAvatar": "ai-features-module-scss-module__zCj01G__chatAvatar",
  "chatBand": "ai-features-module-scss-module__zCj01G__chatBand",
  "chatText": "ai-features-module-scss-module__zCj01G__chatText",
  "chip": "ai-features-module-scss-module__zCj01G__chip",
  "closing": "ai-features-module-scss-module__zCj01G__closing",
  "closingCard": "ai-features-module-scss-module__zCj01G__closingCard",
  "closingGlow": "ai-features-module-scss-module__zCj01G__closingGlow",
  "closingNoise": "ai-features-module-scss-module__zCj01G__closingNoise",
  "coachIdentity": "ai-features-module-scss-module__zCj01G__coachIdentity",
  "coachLabel": "ai-features-module-scss-module__zCj01G__coachLabel",
  "companion": "ai-features-module-scss-module__zCj01G__companion",
  "comparison": "ai-features-module-scss-module__zCj01G__comparison",
  "comparisonBody": "ai-features-module-scss-module__zCj01G__comparisonBody",
  "comparisonCoach": "ai-features-module-scss-module__zCj01G__comparisonCoach",
  "comparisonGeneric": "ai-features-module-scss-module__zCj01G__comparisonGeneric",
  "comparisonNoise": "ai-features-module-scss-module__zCj01G__comparisonNoise",
  "demoInput": "ai-features-module-scss-module__zCj01G__demoInput",
  "description": "ai-features-module-scss-module__zCj01G__description",
  "disclaimer": "ai-features-module-scss-module__zCj01G__disclaimer",
  "earlier": "ai-features-module-scss-module__zCj01G__earlier",
  "exchange": "ai-features-module-scss-module__zCj01G__exchange",
  "faq": "ai-features-module-scss-module__zCj01G__faq",
  "faqAnswer": "ai-features-module-scss-module__zCj01G__faqAnswer",
  "faqAnswerReveal": "ai-features-module-scss-module__zCj01G__faqAnswerReveal",
  "faqArrow": "ai-features-module-scss-module__zCj01G__faqArrow",
  "faqHeading": "ai-features-module-scss-module__zCj01G__faqHeading",
  "faqItem": "ai-features-module-scss-module__zCj01G__faqItem",
  "faqNumber": "ai-features-module-scss-module__zCj01G__faqNumber",
  "fox": "ai-features-module-scss-module__zCj01G__fox",
  "foxAuraCanvas": "ai-features-module-scss-module__zCj01G__foxAuraCanvas",
  "foxBand": "ai-features-module-scss-module__zCj01G__foxBand",
  "foxBreathing": "ai-features-module-scss-module__zCj01G__foxBreathing",
  "foxCanvas": "ai-features-module-scss-module__zCj01G__foxCanvas",
  "foxColor": "ai-features-module-scss-module__zCj01G__foxColor",
  "foxDrawing": "ai-features-module-scss-module__zCj01G__foxDrawing",
  "foxFace": "ai-features-module-scss-module__zCj01G__foxFace",
  "foxFallback": "ai-features-module-scss-module__zCj01G__foxFallback",
  "foxInline": "ai-features-module-scss-module__zCj01G__foxInline",
  "foxStage": "ai-features-module-scss-module__zCj01G__foxStage",
  "foxTrack": "ai-features-module-scss-module__zCj01G__foxTrack",
  "foxTransition": "ai-features-module-scss-module__zCj01G__foxTransition",
  "header": "ai-features-module-scss-module__zCj01G__header",
  "heading": "ai-features-module-scss-module__zCj01G__heading",
  "hero": "ai-features-module-scss-module__zCj01G__hero",
  "heroArtwork": "ai-features-module-scss-module__zCj01G__heroArtwork",
  "heroBackdrop": "ai-features-module-scss-module__zCj01G__heroBackdrop",
  "heroCTAs": "ai-features-module-scss-module__zCj01G__heroCTAs",
  "heroCanvas": "ai-features-module-scss-module__zCj01G__heroCanvas",
  "heroCopy": "ai-features-module-scss-module__zCj01G__heroCopy",
  "heroHatches": "ai-features-module-scss-module__zCj01G__heroHatches",
  "heroHeading": "ai-features-module-scss-module__zCj01G__heroHeading",
  "heroHeadline": "ai-features-module-scss-module__zCj01G__heroHeadline",
  "heroIntro": "ai-features-module-scss-module__zCj01G__heroIntro",
  "heroPin": "ai-features-module-scss-module__zCj01G__heroPin",
  "heroPlane": "ai-features-module-scss-module__zCj01G__heroPlane",
  "heroPlaneIntro": "ai-features-module-scss-module__zCj01G__heroPlaneIntro",
  "heroRotator": "ai-features-module-scss-module__zCj01G__heroRotator",
  "heroTitle": "ai-features-module-scss-module__zCj01G__heroTitle",
  "heroVector": "ai-features-module-scss-module__zCj01G__heroVector",
  "heroVisual": "ai-features-module-scss-module__zCj01G__heroVisual",
  "iconButton": "ai-features-module-scss-module__zCj01G__iconButton",
  "logoGrid": "ai-features-module-scss-module__zCj01G__logoGrid",
  "nameField": "ai-features-module-scss-module__zCj01G__nameField",
  "page": "ai-features-module-scss-module__zCj01G__page",
  "personalize": "ai-features-module-scss-module__zCj01G__personalize",
  "pickerControls": "ai-features-module-scss-module__zCj01G__pickerControls",
  "question": "ai-features-module-scss-module__zCj01G__question",
  "questions": "ai-features-module-scss-module__zCj01G__questions",
  "secondaryCTA": "ai-features-module-scss-module__zCj01G__secondaryCTA",
  "sectionHeadingCTA": "ai-features-module-scss-module__zCj01G__sectionHeadingCTA",
  "selectedSuggestion": "ai-features-module-scss-module__zCj01G__selectedSuggestion",
  "send": "ai-features-module-scss-module__zCj01G__send",
  "steps": "ai-features-module-scss-module__zCj01G__steps",
  "suggestion": "ai-features-module-scss-module__zCj01G__suggestion",
  "suggestions": "ai-features-module-scss-module__zCj01G__suggestions",
  "swatch": "ai-features-module-scss-module__zCj01G__swatch",
  "swatchArt": "ai-features-module-scss-module__zCj01G__swatchArt",
  "swatches": "ai-features-module-scss-module__zCj01G__swatches",
  "wordmark": "ai-features-module-scss-module__zCj01G__wordmark",
  "wordmarkYear": "ai-features-module-scss-module__zCj01G__wordmarkYear",
  "workflow": "ai-features-module-scss-module__zCj01G__workflow",
  "workflowBody": "ai-features-module-scss-module__zCj01G__workflowBody",
  "workflowCard": "ai-features-module-scss-module__zCj01G__workflowCard",
  "workflowCards": "ai-features-module-scss-module__zCj01G__workflowCards",
  "workflowMedia": "ai-features-module-scss-module__zCj01G__workflowMedia",
  "wrapped": "ai-features-module-scss-module__zCj01G__wrapped",
});
